import React from "react";
import { Link } from "gatsby";

const Apply = () => {
  const benefits = [
    {
      imageUrl: "/images/Texas-map.webp",
      description: "You Must Be a Texas Resident.",
    },
    {
      imageUrl: "/svgs/dollar.svg",
      description: "You Must Be Struggling With $10,000 or More Of Debt.",
    },
    {
      imageUrl: "/images/credit-card.webp",
      description:
        "You Must Have High-Interest Credit Cards or Personal Loans.",
    },
    {
      imageUrl: "/svgs/check.svg",
      description: "You must have a verifiable source of income.",
    },
  ];

  return (
    <div className="bg-white py-16 relative">
      <div className="container text-center">
        <h2 className="text-xl md:text-4xl text-black font-bold">
          What do I need to qualify for Debt Relief?
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 my-16">
          {benefits.map(({ imageUrl, description }, index) => (
            <div className="mb-5 sm:mb-0 sm:px-8" key={index}>
              <img
                className="h-[4.2rem] w-auto mx-auto mb-3"
                src={imageUrl}
                alt="Checkmark"
              />
              <p className="text-lg">{description}</p>
            </div>
          ))}
        </div>
        <button className="transition w-full md:w-auto bg-sky-800 hover:bg-sky-900 text-xl md:text-3xl text-white px-8 py-3 rounded-md mb-2">
          <Link to="/apply-loan/">Check Your Eligibility</Link>
        </button>
        <p className="text-lg">This won't affect your credit score.</p>
      </div>
    </div>
  );
};

export default Apply;
